














































import { Vue, Component, Prop } from 'vue-property-decorator';


interface IPrevDataDto {
    checkedOption: string | Record<string, string>; 
    dirObj: Record<string, string>; 
    currYear: number; 
}

@Component
export default class DuplicatePrevYearDataConfirmModal extends Vue {
    @Prop() prevDataDto!: IPrevDataDto; 

    show() {
        this.$bvModal.show('prev-year-confirm-modal');
    }

    handleHide(evt: any) {
      this.$bvModal.hide('prev-year-confirm-modal');
    }

    handleDuplicate() {
        // Resolve translations BEFORE hiding modal
        const toastBody = String(this.$t('modules.srs.warnings.data_duplication_success', { 
            prevYear: this.prevDataDto.currYear - 1 
        }));
        const toastTitle = String(this.$t('modules.srs.warnings.information'));

        this.$emit('duplicate-data-confirmed');
        this.$bvModal.hide('prev-year-confirm-modal');
        this.$nextTick(() => {
            this.makeToast('success', toastBody, toastTitle);
        });
    }


    makeToast(variant: string, tostbody: string, title: string, autoHideDelay?: number): void {
      this.$bvToast.toast(tostbody, {
          title: title,
          variant: variant,
          autoHideDelay: autoHideDelay || 3500,
          solid: true
      });
    }

};
